<template>
  <div class="custom-control custom-checkbox">
      <input :id="`checkbox_${label}`" :checked="selected" @change="change" type="checkbox" class="custom-control-input">
      <label class="custom-control-label" :for="`checkbox_${label}`">{{ label }} ({{ count }})</label>
  </div>
</template>

<script>
export default {
  name: 'ponroy-filter-checkbox',
  props: {
    count: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      required: true
    },
    value: Boolean
  },
  data() {
    return {
      selected: this.value
    }
  },
  watch:{
    value(value){
      this.selected = value;
    }
  },
  methods: {
    change() {
      this.selected = !this.selected;
      this.$emit('input', this.selected);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/FilterCheckbox.vue